import { FC } from 'react';
import { Stack, Box, Text, Textarea, BoxProps } from '@chakra-ui/react';
import { PastCrawlerDetail } from '../../../../types/pastCrawlerDetail';

type Props = BoxProps & {
  detail: PastCrawlerDetail;
};

export const CrawlerDetailItemModalView: FC<Props> = ({
  detail,
  ...boxProps
}) => (
  <Box px="20px" py="10px" {...boxProps}>
    <Stack spacing="24px" direction="column">
      <Stack direction="row">
        <Text w="180px">バージョン</Text>
        <Text>{detail.version}</Text>
      </Stack>
      <Stack direction="row">
        <Text w="180px">説明</Text>
        <Box flex="1">
          <Textarea
            rows={4}
            isReadOnly
            value={detail.description}
            variant="unstyled"
          />
        </Box>
      </Stack>
      <Stack direction="row">
        <Text w="180px">リリース日</Text>
        <Text>{detail.releasedAt}</Text>
      </Stack>
      <Stack direction="row">
        <Text w="180px">手動実行対応</Text>
        <Text>{detail.adhocSupportedIntervals}</Text>
      </Stack>
      <Stack direction="row">
        <Text w="180px">UI表示テンプレート</Text>
        <Box flex="1">
          <Textarea rows={6} isReadOnly value={detail.configTemplate} />
        </Box>
      </Stack>
      <Stack direction="row">
        <Text w="180px">リリースチャンネル</Text>
        <Text>{detail.releasedChannels}</Text>
      </Stack>
    </Stack>
  </Box>
);
